import React from "react";
import Link from "../../components/plain-link";
import { Button, Typography } from "@material-ui/core";
import styled from "styled-components";
import useStyles from "./styles";

export default function Landing() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Welcome />
      <Enter />
    </div>
  );
}

const Welcome = styled((props) => {
  return (
    <Typography {...props} variant="h1">
      Welcome To Spot
    </Typography>
  );
})`
  ${({ theme }) => `
        color: ${theme.palette.primary.dark};
    `}
  font-weight: bold;
  font-size: 5.5rem;
  margin-bottom: 8rem;
`;
function Enter() {
  const classes = useStyles();
  return (
    <Link to="/dashboard">
      <Button className={classes.enter} size="large">
        Ready to study?
      </Button>
    </Link>
  );
}
